(function () {
  'use strict';

  var data = window.__lp03Data || {
    pdpUrl: '/',
    prefix: 'lp03_plaquinha_colo_',
    enableStickyCta: true,
    enableAnimations: true
  };

  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var animationsOn = data.enableAnimations && !reducedMotion;

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event: data.prefix + 'view' });

  function track(event, payload) {
    var obj = { event: data.prefix + event };
    if (payload) {
      for (var k in payload) if (Object.prototype.hasOwnProperty.call(payload, k)) obj[k] = payload[k];
    }
    window.dataLayer.push(obj);
  }

  /* ---------- Countdown ---------- */
  function initCountdown() {
    var el = document.querySelector('.lp03-countdown');
    if (!el) return;
    var endIso = el.getAttribute('data-end');
    if (!endIso) return;
    var endTime = new Date(endIso).getTime();
    if (isNaN(endTime)) return;

    var dEl = el.querySelector('[data-c="days"]');
    var hEl = el.querySelector('[data-c="hours"]');
    var mEl = el.querySelector('[data-c="mins"]');
    var sEl = el.querySelector('[data-c="secs"]');
    var expired = false;

    function pad(n) { return n < 10 ? '0' + n : '' + n; }

    function tick() {
      var now = Date.now();
      var diff = endTime - now;
      if (diff <= 0) {
        if (!expired) {
          expired = true;
          el.classList.add('is-expired');
          track('countdown_expired');
        }
        if (dEl) dEl.textContent = '00';
        if (hEl) hEl.textContent = '00';
        if (mEl) mEl.textContent = '00';
        if (sEl) sEl.textContent = '00';
        return;
      }
      var days = Math.floor(diff / 86400000);
      var hours = Math.floor((diff % 86400000) / 3600000);
      var mins = Math.floor((diff % 3600000) / 60000);
      var secs = Math.floor((diff % 60000) / 1000);
      if (dEl) dEl.textContent = pad(days);
      if (hEl) hEl.textContent = pad(hours);
      if (mEl) mEl.textContent = pad(mins);
      if (sEl) sEl.textContent = pad(secs);
    }
    tick();
    setInterval(tick, 1000);
  }

  /* ---------- Testimonials Rotating ---------- */
  function initRotating() {
    var wrap = document.querySelector('.lp03-testimonials-rotating__wrap');
    if (!wrap) return;
    var slides = wrap.querySelectorAll('.lp03-rotating-slide');
    var dots = wrap.querySelectorAll('.lp03-rotating-dots .lp03-dot');
    if (!slides.length) return;
    var seconds = parseInt(wrap.getAttribute('data-autoplay') || '4', 10);
    var current = 0;
    var timer = null;

    function show(i) {
      current = (i + slides.length) % slides.length;
      slides.forEach(function (s, idx) {
        s.classList.toggle('is-active', idx === current);
      });
      dots.forEach(function (d, idx) {
        d.classList.toggle('is-active', idx === current);
        d.setAttribute('aria-current', idx === current ? 'true' : 'false');
      });
      track('testimonial_slide', { slide_number: current + 1 });
    }

    function start() {
      if (reducedMotion) return;
      stop();
      timer = setInterval(function () { show(current + 1); }, seconds * 1000);
    }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }

    dots.forEach(function (d, idx) {
      d.addEventListener('click', function () { show(idx); start(); });
    });

    // swipe
    var startX = 0;
    wrap.addEventListener('touchstart', function (e) {
      startX = e.touches[0].clientX;
      stop();
    }, { passive: true });
    wrap.addEventListener('touchend', function (e) {
      var dx = e.changedTouches[0].clientX - startX;
      if (Math.abs(dx) > 40) show(current + (dx < 0 ? 1 : -1));
      start();
    }, { passive: true });

    slides[0].classList.add('is-active');
    dots.forEach(function (d, i) { if (i === 0) d.classList.add('is-active'); });
    start();
  }

  /* ---------- FAQ Accordion ---------- */
  function initFAQ() {
    document.querySelectorAll('.lp03-faq__item').forEach(function (item) {
      var btn = item.querySelector('.lp03-faq__question');
      var answer = item.querySelector('.lp03-faq__answer');
      if (!btn || !answer) return;
      btn.setAttribute('aria-expanded', 'false');

      function toggle() {
        var isOpen = item.classList.contains('is-open');
        document.querySelectorAll('.lp03-faq__item.is-open').forEach(function (openItem) {
          openItem.classList.remove('is-open');
          var ob = openItem.querySelector('.lp03-faq__question');
          var oa = openItem.querySelector('.lp03-faq__answer');
          if (ob) ob.setAttribute('aria-expanded', 'false');
          if (oa) oa.style.maxHeight = '0';
        });
        if (!isOpen) {
          item.classList.add('is-open');
          btn.setAttribute('aria-expanded', 'true');
          answer.style.maxHeight = answer.scrollHeight + 'px';
          var qtext = btn.querySelector('.lp03-faq__question-text');
          track('faq_expand', {
            question: qtext ? qtext.textContent.trim() : btn.textContent.trim()
          });
        }
      }
      btn.addEventListener('click', toggle);
      btn.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggle(); }
      });
    });
  }

  /* ---------- Sticky CTA Mobile ---------- */
  function initStickyCta() {
    if (!data.enableStickyCta) return;
    var sticky = document.querySelector('.lp03-sticky-cta');
    if (!sticky) return;
    var shown = false;
    var threshold = window.innerHeight * 0.8;

    function onScroll() {
      var scrolled = window.scrollY > threshold;
      sticky.classList.toggle('is-visible', scrolled);
      if (scrolled && !shown) {
        shown = true;
        track('sticky_shown');
      }
    }
    window.addEventListener('scroll', onScroll, { passive: true });

    if ('IntersectionObserver' in window) {
      var card = document.querySelector('.lp03-ctacard');
      if (card) {
        var ob = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            sticky.classList.toggle('is-hidden-by-card', entry.isIntersecting);
          });
        }, { threshold: 0.15 });
        ob.observe(card);
      }
    }
  }

  /* ---------- Reveal on Scroll ---------- */
  function initReveal() {
    if (!animationsOn) {
      document.querySelectorAll('.lp03-reveal, .lp03-stagger, .lp03-image-reveal').forEach(function (el) {
        el.classList.add('is-visible');
      });
      return;
    }
    if (!('IntersectionObserver' in window)) return;

    var opts = { threshold: 0.1, rootMargin: '0px 0px -40px 0px' };

    var revealOb = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          revealOb.unobserve(entry.target);
        }
      });
    }, opts);

    document.querySelectorAll('.lp03-block').forEach(function (block) {
      block.classList.add('lp03-reveal');
      revealOb.observe(block);
    });
    document.querySelectorAll('.lp03-stagger').forEach(function (el) { revealOb.observe(el); });
    document.querySelectorAll('.lp03-image-reveal').forEach(function (el) { revealOb.observe(el); });
  }

  /* ---------- CTA Click Tracking ---------- */
  function initCtaTracking() {
    var pdpUrl = data.pdpUrl;
    var pos = 0;
    document.querySelectorAll('.lp03-cta').forEach(function (cta) {
      pos++;
      var blockEl = cta.closest('[data-block-type]');
      var blockType = blockEl ? blockEl.getAttribute('data-block-type') : 'unknown';
      var myPos = pos;
      cta.addEventListener('click', function (e) {
        var href = cta.getAttribute('href');
        if (cta.hasAttribute('data-no-redirect')) {
          track('cta_click', { block: blockType, position: myPos });
          return;
        }
        e.preventDefault();
        track('cta_click', { block: blockType, position: myPos });
        setTimeout(function () {
          window.location.href = href && href !== '#' ? href : pdpUrl;
        }, 140);
      });
    });
  }

  /* ---------- Scroll Depth ---------- */
  function initScrollDepth() {
    var fired = {};
    function onScroll() {
      var docHeight = document.documentElement.scrollHeight - window.innerHeight;
      if (docHeight <= 0) return;
      var pct = Math.round((window.scrollY / docHeight) * 100);
      [25, 50, 75, 100].forEach(function (d) {
        if (!fired[d] && pct >= d) {
          fired[d] = true;
          track('scroll_depth', { percent: d });
        }
      });
    }
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ---------- Video Play ---------- */
  function initVideo() {
    document.querySelectorAll('.lp03-video__player').forEach(function (player) {
      var url = player.getAttribute('data-video-url');
      if (!url) return;
      player.addEventListener('click', function () {
        var embed = toEmbedUrl(url);
        if (!embed) return;
        var iframe = document.createElement('iframe');
        iframe.src = embed;
        iframe.allow = 'autoplay; encrypted-media; picture-in-picture';
        iframe.allowFullscreen = true;
        iframe.setAttribute('frameborder', '0');
        player.innerHTML = '';
        player.appendChild(iframe);
        track('video_play');
      }, { once: true });
    });
  }
  function toEmbedUrl(url) {
    var yt = url.match(/(?:youtube\.com\/watch\?v=|youtu\.be\/|youtube\.com\/embed\/)([^&?/]+)/);
    if (yt) return 'https://www.youtube.com/embed/' + yt[1] + '?autoplay=1&rel=0';
    var vm = url.match(/vimeo\.com\/(?:video\/)?(\d+)/);
    if (vm) return 'https://player.vimeo.com/video/' + vm[1] + '?autoplay=1';
    return null;
  }

  /* ---------- Init ---------- */
  function init() {
    initCountdown();
    initRotating();
    initFAQ();
    initStickyCta();
    initReveal();
    initCtaTracking();
    initScrollDepth();
    initVideo();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
